<template lang="pug">
  section
    el-row
      el-col(:span="24")
        h4.card-title Resultado da pesquisa
        div(class="card-body")
          el-table(
            :data="dados"
            style="cursor: pointer"
          )
            el-table-column(
              fixed
              label='Nº do processo',
              min-width="150",
              prop="numeroProcesso"
            )
            el-table-column(
              fixed
              label='Ordem de serviço',
              min-width="250",
              prop="ordensServico"
            )
            el-table-column(
              label='Município',
              min-width="150",
              prop="municipioFormatado"
            )
            el-table-column(
              label='Geomensor / Fiscalizador',
              min-width="200",
              prop="geomensor"
            )
            el-table-column(
              label='Situação do Geomensor / Fiscalizador',
              min-width="250",
              prop="situacaoGeomensor"
            )
            el-table-column(
              label='Vistoriador',
              min-width="180",
              prop="vistoriador"
            )
            el-table-column(
              label='Situação do vistoriador',
              min-width="200",
              prop="situacaoVistoriador"
            )
            el-table-column(
              label='Data do processo',
              min-width="140",
              prop="dataFormatada"
            )
</template>

<script>

export default {
  props: {
    dados: {
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/styles/_variables.scss';

 .card-title {
   margin-left: 33px;
  }
</style>



// WEBPACK FOOTER //
// src/screens/relatorios/components/os/TabelaProcesso.vue